// @generated by protoc-gen-es v1.10.0
// @generated from file fingertip/common/type/v1/booking.proto (package fingertip.common.type.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { BookingResponse } from "./booking_response_pb.js";
import { BookingStatus } from "../../enum/v1/booking_status_pb.js";
import { PaymentCollectionType } from "../../enum/v1/payment_collection_type_pb.js";
import { AttendanceType } from "../../enum/v1/attendance_type_pb.js";

/**
 * @generated from message fingertip.common.type.v1.Booking
 */
export const Booking = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.Booking",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "event_type_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "response", kind: "message", T: BookingResponse },
    { no: 8, name: "start_time", kind: "message", T: Timestamp },
    { no: 9, name: "end_time", kind: "message", T: Timestamp },
    { no: 11, name: "location", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "status", kind: "enum", T: proto3.getEnumType(BookingStatus) },
    { no: 14, name: "destination_calendar_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "cancellation_reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "rejection_reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 17, name: "rescheduled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 18, name: "from_reschedule", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 19, name: "recurring_event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 20, name: "sms_reminder_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 22, name: "metadata", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 23, name: "is_recorded", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 24, name: "created_at", kind: "message", T: Timestamp },
    { no: 25, name: "updated_at", kind: "message", T: Timestamp },
    { no: 26, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 27, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 28, name: "source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 29, name: "rescheduled_reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 30, name: "site_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 44, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 51, name: "cancellation_charged_at", kind: "message", T: Timestamp },
    { no: 52, name: "no_show_charged_at", kind: "message", T: Timestamp },
    { no: 53, name: "booking_charged_at", kind: "message", T: Timestamp },
    { no: 54, name: "cancellation_late_after_date", kind: "message", T: Timestamp },
    { no: 55, name: "refundable", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 56, name: "payment_collection_type", kind: "enum", T: proto3.getEnumType(PaymentCollectionType) },
    { no: 57, name: "event_type_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 58, name: "event_type_description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 59, name: "event_type_length", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 60, name: "booking_policy", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 61, name: "attendance_type", kind: "enum", T: proto3.getEnumType(AttendanceType) },
    { no: 62, name: "max_attendees", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 63, name: "requires_confirmation", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 64, name: "confirmed_at", kind: "message", T: Timestamp },
    { no: 65, name: "cancelled_at", kind: "message", T: Timestamp },
    { no: 66, name: "rejected_at", kind: "message", T: Timestamp },
    { no: 67, name: "completed_at", kind: "message", T: Timestamp },
    { no: 68, name: "cancel_beyond_confirmation_date", kind: "message", T: Timestamp },
    { no: 69, name: "form_response_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 70, name: "store_invoice_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 71, name: "price_in_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 72, name: "no_show_fee_in_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 73, name: "cancellation_fee_in_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 74, name: "disable_reschedule", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

